import { render, staticRenderFns } from "./ClientJbbfBaseInputGroup.vue?vue&type=template&id=8c84123c&scoped=true&"
import script from "./ClientJbbfBaseInputGroup.vue?vue&type=script&lang=js&"
export * from "./ClientJbbfBaseInputGroup.vue?vue&type=script&lang=js&"
import style0 from "./ClientJbbfBaseInputGroup.vue?vue&type=style&index=0&id=8c84123c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c84123c",
  null
  
)

export default component.exports